import { render, staticRenderFns } from "./SectionJoin.vue?vue&type=template&id=6e6bbe47&scoped=true"
import script from "./SectionJoin.vue?vue&type=script&lang=js"
export * from "./SectionJoin.vue?vue&type=script&lang=js"
import style0 from "./SectionJoin.vue?vue&type=style&index=0&id=6e6bbe47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6bbe47",
  null
  
)

export default component.exports